export enum Locales {
	En = 'en',
	De = 'de',
}

export interface InitialData {
	locale: Locales;
	languages: string[] | null;
}
